import Component from '../../../scripts/utilities/component';

class Modal extends Component {
    componentDidMount() {
        if (typeof Event === 'function') {
            this.event = new Event('modelClosed');
        } else {
            this.event = document.createEvent('Event');
            this.event.initEvent('modelClosed', true, true);
        }

        this.modalRef = this.props.modalRef;
        this.showModalBtn = this.mount.querySelector(`[data-target-modal="${this.modalRef}"]`);
        this.hideModalBtn = [...this.root.querySelectorAll('[data-ref="hide-modal"]')];

        if (this.showModalBtn && this.hideModalBtn) {
            this.bindEventListeners();
        }
    }

    bindEventListeners() {
        this.root.addEventListener('click', (e) => {
            const elm = e.target;

            if (elm.classList.contains('is--open')) {
                this.root.classList.remove('is--open');
            }
        });

        this.showModalBtn.addEventListener('click', this.toggleModal.bind(this), true);
        this.hideModalBtn.forEach((hideBtn) => {
            hideBtn.addEventListener('click', this.toggleModal.bind(this), true);
        });

        document.addEventListener('keyup', (e) => {
            if (e.keyCode === 27) {
                this.root.classList.remove('is--open');
            }
        });
    }

    toggleModal(e) {
        e.preventDefault();
        const btnRef = e.currentTarget.getAttribute('data-ref');

        if (btnRef === 'hide-modal') {
            this.root.classList.remove('is--open');
        } else {
            this.root.classList.add('is--open');
        }

        if (!this.root.classList.contains('is--open')) {
            document.dispatchEvent(this.event);
        }
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./components/eng-ms-modal/scripts/modal.js